export default {
  init() {
    // JavaScript to be fired on all pages

    // HAMBURGER DROPDOWN LINKS CLIKC auto close dorpdown
    $('.navbar-nav>li>a').on('click', function (){
      $('.navbar-collapse').collapse('hide');
    });

    $('[data-toggle="tooltip"]').tooltip();

    $('#gallery-page').lightGallery({
      selector: '.gallery-link',
    });

    // SUBS MESSAGE
    const subscriptionMessageContainer = $('#subscription-message-container');
    const destinationMessageContainer = $('body.pmpro-body-level-required.live-stream .pmpro_content_message');
    destinationMessageContainer.html(subscriptionMessageContainer);

    // Pause YouTube videos when modal closes
    $('.modal .close-icon, .modal .modal-backdrop').click(function() {
      const modal = $(this).closest('.modal');
      modal.find('.video-embed iframe').each(function() {
        if ($(this).attr('src') && $(this).attr('src').includes('youtube')) {
          try {
            $(this)[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } catch (error) {
            // Silently handle error
          }
        }
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js